module.exports = __webpack_public_path__ + "3806b178192c251aab1386a28a2475ca.pdf";